export const step36end = {
    id: 36,
    title: 'Děkujeme!',
    taskText: `
        <p>
            Moc ti děkuju, že jsi mi pomohl rozluštit tuhle obrovskou záhadu. Jsem rád, že jsme si to spolu tak užili. Nevím jak ty, ale já jsem se rozhodně nenudil 🙂
        </p>
        <p>    
            Teď jako jedni z mála víme, proč se tomuhle místu říká Zelená hora, i když tu tedy už moc té zelené není.
            To se mi ulevilo, štve mě, když něčemu nerozumím. A kolik nám pomohlo lidí, teda vlastně duchů... upíři, mušketýři, hraběnky, 
            a ani nebyli tak strašidelní.
        </p>
    `,
    points: false,
};
